import * as Yup from "yup";

const getValidationSchema = () => {
  let baseSchema = {
    title: Yup.string().required("title is required"),
    fullName: Yup.string().required("fullName is required"),
    email: Yup.string().email("Invalid Email").required("email is required"),
    formType: Yup.boolean()
      .required("Choose upload or fill-up recomendation form")
      .nullable(),
    documentUpload: Yup.string().when("formType", {
      is: (value) => value == true,
      then: (schema) => schema.required("document Upload is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    howLongYouKnowAdmin: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    context: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    otherContext: Yup.string().when("context", {
      is: (value) => value == "2",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    personalityText: Yup.string().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("personalityText is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    additionalComments: Yup.string().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("additionalComments is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    evaluatorName: Yup.string().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("evaluatorNameis required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    titlePosition: Yup.string().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("titlePosition is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    company: Yup.string().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("company is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    intellectualAbility: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("intellectualAbility is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    analyticalAbility: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("analyticalAbility is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    leadershipPotential: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("leadershipPotential is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    teamworkSkills: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("teamworkSkills is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    planningSkills: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("planningSkills is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    communicationSkills: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("communicationSkills is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    overall: Yup.number().when("formType", {
      is: (value) => value == false,
      then: (schema) => schema.required("company is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  };

  return Yup.object().shape(baseSchema);
};

export default getValidationSchema;
